import styles from './index.module.scss'
import styles2 from '../index.module.scss'
import { Pagination, Row, Checkbox, Input, message, Table, Spin } from 'antd'
import { useState, useEffect, useRef, useContext, useMemo } from 'react'
import TeamTable from './TeamTable'
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';
import TopWrap from '../hooks/TopWrap';
import API from '@api/api';


const PersonalTransaction = () => {
    const { globalUser, globalOrgInfo, globalBalance, globalFreeze } = useContext(AppContext);
    const [logLoading, setLogLoading] = useState(false)
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(20)
    const [total, setTotal] = useState(0)
    const [allLogList, setAllLogList] = useState([])
    const [orgInfoLoading, setOrgInfoLoading] = useState(true); // 组织信息加载状态
    const logColumns = [{
        title: '扣点项目',
        key: 'title',
        minWidth: 150,
        render: (record) => record.title,
    }, {
        title: '扣除虹豆数',
        dataIndex: 'amount',
        key: 'amount',
        minWidth: 150,
    }, {
        title: '操作时间',
        dataIndex: 'createdTime',
        key: 'createdTime'
    }]

    const logList = useMemo(() => {
        const startIndex = (pageIndex - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return allLogList.slice(startIndex, endIndex);
    }, [allLogList, pageIndex, pageSize]);

    const getUsageBillList = () => {
        setLogLoading(true)
        API.getUsageBillList({
        }).then((res) => {
            if (res.code !== 0) message.error(res.message)
            const dataWithKeys = res.data.map((item, key) => ({ ...item, key }))
            setAllLogList(dataWithKeys)
            setTotal(dataWithKeys.length)
        }).catch(err => {
            console.error(err)
        }).finally(() => {
            setLogLoading(false)
        })
    }

    useEffect(() => {
        if (localStorage.getItem('token') && !globalOrgInfo) {
            eventBus.emit('updateUserInfo');
            eventBus.emit('getUserOrgInfo');
        }
    }, [globalOrgInfo]);

    useEffect(() => {
        if (globalOrgInfo !== undefined) {
            setOrgInfoLoading(false);
            getUsageBillList();
        }
    }, [globalOrgInfo]);


    const pageChange = pageNumber => {
        setPageIndex(pageNumber)
    };

    return (
        <div className={styles.personalTransaction}>
            <TopWrap type="transaction" />
            <div className={styles2.tableWrap}>
                {orgInfoLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                        <Spin size="large" tip="加载中..." />
                    </div>
                ) : (
                    globalOrgInfo?.isPersonal ? (
                        <>
                            <Table
                                className='personalTable'
                                loading={logLoading}
                                rowKey="key"
                                columns={logColumns}
                                dataSource={logList}
                                pagination={false}
                                tableLayout="auto"
                                scroll={{
                                    x: 'max-content',
                                    y: `calc(100vh - 520px)`,
                                }}
                            />
                            <div className={styles2.PaginationWarp}>
                                <Pagination
                                    showQuickJumper
                                    total={total}
                                    onChange={pageChange}
                                    pageSize={pageSize}
                                    current={pageIndex}
                                    showSizeChanger={false} />
                            </div>
                        </>
                    ) : (
                        <TeamTable />
                    )
                )}
            </div>

        </div>
    )
}

export default PersonalTransaction